exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.filter_heading[data-v-855993d6] {\n  font-weight: bold;\n}\n.filter_sub[data-v-855993d6] {\n  margin-left: 10px;\n}\n", ""]);
